var _defs, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNotificationsOff = function SvgNotificationsOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".notifications-off_svg__a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.25,
    cy: 6.75,
    r: 6,
    className: "notifications-off_svg__a"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m15.375 8.625 3.75-3.75M19.125 8.625l-3.75-3.75M7.748 21.75a2.087 2.087 0 0 0 4.005 0M17.505 15.862a7.4 7.4 0 0 0 1.245 2.888h-18s1.5-2.329 1.5-8.25A7.5 7.5 0 0 1 9.75 3V.75",
    className: "notifications-off_svg__a"
  })));
};
export default SvgNotificationsOff;